import React from "react";
import { Crown, Zap } from "lucide-react";

const CONFIG = {
  pro: { label: "Pro", color: "#2563EB", tint: "#EFF4FF", Icon: Zap },
  elite: { label: "Elite", color: "#B45309", tint: "#FEF3C7", Icon: Crown },
};

// Insignia de prestigio de membresía (Pro/Elite). No renderiza nada para básico.
export function PlanBadge({ plan, size = "sm", className = "" }) {
  const c = CONFIG[plan];
  if (!c) return null;
  const { Icon } = c;
  const dims = size === "lg"
    ? "text-xs px-2.5 py-1 gap-1.5"
    : "text-[10px] px-2 py-0.5 gap-1";
  const iconSize = size === "lg" ? 13 : 11;
  return (
    <span
      data-testid={`plan-badge-${plan}`}
      title={`Miembro ${c.label} de ConstruLink`}
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wide ${dims} ${className}`}
      style={{ color: c.color, backgroundColor: c.tint, border: `1px solid ${c.color}33` }}
    >
      <Icon size={iconSize} style={{ color: c.color }} />
      {c.label}
    </span>
  );
}

export default PlanBadge;
